const getCrossSaleCategories = ( categories ) => {
    return categories.filter( cat => (
        parseInt(cat.is_crossale)
    ))
}

export default getCrossSaleCategories;